module.exports = __webpack_public_path__ + "img/heart.083722b0.svg";